export class RestoreTemplate {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "RestoreTemplateResourceType",
            "format": ""
        },
        {
            "name": "ec2Params",
            "baseName": "ec2Params",
            "type": "Ec2TemplateParams",
            "format": ""
        },
        {
            "name": "s3Params",
            "baseName": "s3Params",
            "type": "S3TemplateParams",
            "format": ""
        },
        {
            "name": "attachedResourceCount",
            "baseName": "attachedResourceCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return RestoreTemplate.attributeTypeMap;
    }
    constructor() {
    }
}
